import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SanitizeInputFormDirective } from './utilities/sanitize-input-form.directive';
import { SanitizeInputDirective } from './utilities/sanitize-input.directive';

@NgModule({
  declarations: [SanitizeInputFormDirective, SanitizeInputDirective],
  imports: [CommonModule],
  exports: [SanitizeInputFormDirective, SanitizeInputDirective] 
})
export class SharedModule {}